export async function typeahead(name) {
  if (!name) return;
  return fetch(`/api/employees?name=${name}&active=false&returnType=succinct`).then(res =>
    res.ok ? res.json() : Promise.reject(res)
  );
}
